/* Pure geometry and timeline helpers for Bed&Bloom bedding deconstruction sequence */
((root) => {
  'use strict';
  const clamp = (value, low = 0, high = 1) => Math.max(low, Math.min(high, value));
  const crop = Object.freeze({ x: 0, y: 0, width: 1280, height: 720 });

  // 40-frame sequence maps from 15% to 75% scroll progress; last 25% is interactive stationary layer exploration
  const frameAt = progress => Math.round(clamp((clamp(progress) - 0.15) / 0.6) * 39);
  const progressAt = (scroll, start, sectionHeight, stageHeight) =>
    clamp((scroll - start) / Math.max(1, sectionHeight - stageHeight));

  function composition(width, height, headerHeight) {
    const top = Math.min(headerHeight + 10, height * 0.24);
    const available = Math.max(1, height - top - 86);
    const scale = Math.min(width / crop.width, available / crop.height);
    const w = crop.width * scale;
    const h = crop.height * scale;
    return {
      left: (width - w) / 2,
      top: top + (available - h) / 2,
      width: w,
      height: h,
      scale
    };
  }

  const helpers = Object.freeze({ clamp, crop, frameAt, progressAt, composition });
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = helpers;
  } else {
    root.BBSequenceMath = helpers;
  }
})(typeof window === 'undefined' ? globalThis : window);
